import { FuelSlider, FuelTypography } from '@frete.com/fuel-react';
import { FuelSliderEvent } from '@frete.com/fuel-components/dist/types/components/slider/slider';

import React, { FC } from 'react';
import * as Styled from './styled';

const Distance: FC<{ sliderValue: number; setSliderValue: (value: number) => void }> = ({
  sliderValue,
  setSliderValue,
}) => {
  const valueDefault = sliderValue < 5 ? 5 : sliderValue;

  return (
    <Styled.WrapperSlider>
      <FuelTypography size="body-sm" weight="bold">
        {`${valueDefault}km`}
      </FuelTypography>

      <FuelSlider
        role="slider"
        label="Raio"
        value={`[${valueDefault / 2}]`}
        unit="km"
        data-testid="slider-distance"
        marks={[
          { value: 5, label: '5' },
          { value: 25, label: '50' },
          { value: 50, label: '100' },
          { value: 75, label: '150' },
          { value: 100, label: '200' },
        ]}
        onFuel-input={(event: CustomEvent<FuelSliderEvent>) => setSliderValue(Number(event.detail.value) * 2)}
        hideValueLabel
      />
    </Styled.WrapperSlider>
  );
};

export default Distance;
